/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./createGrant.defs.js";
export { main as default } from "./createGrant.defs.js";
